import React, { useState, useEffect, useRef } from "react";
import useFilter from "Utils/useFilter";
import { Icon, search, close } from "Icons/index";
import cx from "classnames";
import t from "Utils/translation";

const TextInputFilter = ({
  className,
  onSubmit,
  name,
  disabled = false,
  label = null,
  placeholder = "",
  value,
  onChange,
  isActive = false,
}) => {
  const inputRef = useRef(null);

  const onKeyUp = (e) => {
    if (e.keyCode === 13) {
      inputRef.current.blur();

      submit(value);
    }
  };

  const submit = (v) => {
    if (onSubmit) {
      onSubmit({
        [name]: v,
      });
    }
  };

  const reset = () => {
    submit(undefined);
    onChange("");
  };

  const inputClassname = cx([
    "w-full",
    "h-10",
    "text-sm",
    "leading-10",
    "border",
    "border-solid",
    "border-[--input-border]",
    "pr-[1.7rem]",
    "pl-[0.375rem]",
    "rounded",
    "box-border",
    "shadow-none",
    "appearance-none",
    "transition-[border]",
    "duration-[50ms]",
    "ease-in-out",
    "md:h-8",
    "md:leading-8",
    "hover:border-[--input-border-hover]",
    "focus:border-qb-blue",
    "focus:outline-none",
    "placeholder:text-sm",
    "placeholder:text-qb-text",
    "placeholder:opacity-50",
    "bg-white",
  ]);

  return (
    <div
      className={cx(
        {
          ["opacity-50 pointer-events-none"]: disabled,
        },
        "flex flex-col w-full"
      )}
    >
      {label && <div className="text-sm text-qb-text">{label}</div>}
      <div className={cx("w-full relative", label && "mt-1", className)}>
        <input
          ref={inputRef}
          disabled={disabled}
          placeholder={placeholder || t("input.placeholder.filters")}
          onKeyUp={onKeyUp}
          className={cx(inputClassname, isActive ? "text-qb-blue" : "text-qb-text")}
          // defaultValue={initialValue}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />

        <div className="flex justify-center items-center rounded absolute right-1 top-1 p-[0.3rem] cursor-pointer hover:bg-[--accent-l35]">
          {isActive ? (
            <Icon
              svg={close}
              width="0.875rem"
              height="0.875rem"
              onClick={reset}
              className={cx("flex flex-col justify-center items-center svg-accent", {
                ["opacity-50 pointer-events-none"]: disabled,
              })}
            />
          ) : (
            <Icon
              svg={search}
              width="0.875rem"
              height="0.875rem"
              onClick={() => submit(value)}
              className={cx("flex flex-col justify-center items-center svg-accent", {
                ["opacity-50 pointer-events-none"]: disabled,
              })}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TextInputFilter;
